import {StyledDotsAnimation} from './style'

export const DotsLoader = () => {
    return <StyledDotsAnimation />
}
